/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-imports */
import React, { useState, useEffect, useRef } from "react";
/*eslint-disable-next-line*/
import { shallowEqual, useSelector } from "react-redux";
//import { EditNewCampione } from "./components/EditNewCampione";
import { Chip, TextField, Avatar, Input } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { Skeleton } from "@material-ui/lab";
import * as PropTypes from "prop-types";

import {
  Eye,
  EyeSlashFill,
  TagFill,
  TagsFill,
  BoxSeamFill,
  Calendar,
} from "react-bootstrap-icons";

import {
  SortingState,
  IntegratedSorting,
  PagingState,
  IntegratedPaging,
  FilteringState,
  IntegratedFiltering,
  DataTypeProvider,
  RowDetailState,
} from "@devexpress/dx-react-grid";
import {
  Grid,
  Table,
  TableHeaderRow,
  PagingPanel,
  TableFilterRow,
  TableRowDetail,
} from "@devexpress/dx-react-grid-bootstrap4";
import "@devexpress/dx-react-grid-bootstrap4/dist/dx-react-grid-bootstrap4.css";
import SVG from "react-inlinesvg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBox, faBoxOpen, faPrint, faSquareCheck, faTruck, faXmark } from "@fortawesome/free-solid-svg-icons";
import TrackingCodeInput from "../Common/TrackingCodeInput";
/*eslint-disable-next-line*/
import { Form, Card, Tooltip, OverlayTrigger, Button, Modal } from "react-bootstrap";
import moment from "moment-timezone";

import { roles, roleOptionsForSelect, icons, statusRichiesta } from "../../config/config";
import * as apiCampioni from "../../api/campioni";
import * as apiRichieste from "../../api/richieste";
import * as apiTracking from "../../api/tracking";
import ArticoloEventoPicker from "./components/ArticoloEventoPicker";
import { useIsMobile } from "../../useIsMobile";
// import "./responsive-table.css";
// import "./img-in-table.css";
// import "./row-detail-compact.css";

function groupRichieste(list) {
  const map = new Map();
  list.forEach((item) => {
    const collection = map.get(item.idRichiesta);
    const {
      idRichiesta,
      idAgente,
      status,
      dateCreated,
      agente,
      address,
      extra,
      quantity,
      idCampione,
      sku,
      qta,
      campione,
      division,
      image,
      lot,
      price,
      trackingCode,
    } = item;
    if (!collection) {
      map.set(idRichiesta, {
        idRichiesta,
        idAgente,
        status: parseInt(status),
        dateCreated,
        agente,
        address,
        extra: !!(extra),
        trackingCode,
        cart: [
          {
            idCampione,
            sku: sku,
            qta: qta,
            name: campione,
            quantity: parseInt(quantity),
            lot: parseInt(lot),
            price: parseFloat(price),
            division,
            image,
            previous: item.previous ? item.previous.filter((p) => p.data !== null) : [],
          },
        ],
      });
    } else {
      collection.cart.push({
        idCampione,
        name: campione,
        sku: sku,
        qta: qta,
        quantity: parseInt(quantity),
        lot: parseInt(lot),
        price: parseFloat(price),
        division,
        image,
        previous: item.previous ? item.previous.filter((p) => p.data !== null) : [],
      });
    }
  });
  for (let [idRichiesta, richiesta] of map) {
    map.set(idRichiesta, {
      ...richiesta,
      quantity: richiesta.cart.reduce((q, item) => q + item.quantity, 0),
    });
  }
  return map;
}

// Useful sub-components
const TableComponent = ({ ...restProps }) => (
  <Table.Table {...restProps} className="table table-hover table-head-custom table-vertical-center overflow-hidden" />
);

const wrapColumns = ["agente", "address"];
const HeaderCell = ({ column, ...restProps }) => {
  const isCentered = ["quantity", "extra"].includes(column.name);
  const isWrapped = wrapColumns.includes(column.name);
  return (
    <TableHeaderRow.Cell {...restProps} className={isWrapped ? "cell-wrap" : undefined}>
      {isCentered ? (
        <div className="text-center" style={{ textAlign: "center", fontWeight: "bold" }}>
          {restProps.children}
        </div>
      ) : (
        restProps.children
      )}
    </TableHeaderRow.Cell>
  );
};

const Cell = (props) => {
  const { column } = props;
  const isWrapped = wrapColumns.includes(column.name);
  return <Table.Cell {...props} className={isWrapped ? "cell-wrap" : undefined} />;
};

const getTableRow = (clickCallback) => {
  return ({ row, ...restProps }) => (
    <Table.Row
      {...restProps}
      // eslint-disable-next-line no-alert
      onClick={() => clickCallback(restProps.tableRow.rowId)}
      style={{
        cursor: "pointer",
      }}
    />
  );
};

const FilterCell = (props) => {
  const { column } = props;
  // if (["quantity", "extra"].includes(column.name)) {
  //    return <TableFilterRow.Cell {...props} />;
  // }
  return <TableFilterRow.Cell {...props} />;
};
FilterCell.propTypes = {
  column: PropTypes.shape({ name: PropTypes.string }).isRequired,
};

const DateFormattedColumn = (props) => (
  <DataTypeProvider formatterComponent={({ value }) => moment(value).format("DD MMMM YYYY, HH:mm")} {...props} />
);

// Componente dedicato per gestire Tracking Code con stato locale
// TrackingCodeInput estratto in componente separato

const makeActionBtn = ({ name, disabled, tooltip, callback, variant, icon, value, className }) => {
  const btn = (
    <Button
      variant={variant}
      className={className ?? `mx-3 my-2`}
      onClick={!disabled ? () => callback(value) : null}
      disabled={disabled}
      title={name}
    >
      {typeof icon == "string" ? (
        <span className={`d-inline-flex svg-icon`}>
          {" "}
          <SVG className={`svg-icon-md svg-icon-white`} src={toAbsoluteUrl(icon)} />
        </span>
      ) : (
        <FontAwesomeIcon icon={icon} className={`svg-icon-white svg-icon-md`} style={{ marginRight: "0.5rem" }} />
      )}
      <span className="text-white">{name}</span>
      {/* {name} */}
    </Button>
  );
  if (!tooltip) return btn;
  return <OverlayTrigger overlay={<Tooltip>{tooltip}</Tooltip>}>{btn}</OverlayTrigger>;
};

const StatoColumn = ({ value }) => {
  /*eslint-disable-next-line*/
  if (value == statusRichiesta.inAttesa)
    return (
      // in attesa
      <div className="pl-0">
        <Chip
          // color="info"
          variant="outlined"
          label="In attesa"
          icon={<FontAwesomeIcon icon={faBoxOpen} className="svg-icon-info svg-icon-md" />}
          style={{ borderColor: "var(--info)", color: "var(--info)" }}
        />
      </div>
    );
  /*eslint-disable-next-line*/
  // if (value == statusRichiesta.approvato)
  //   return (
  //     // approvato
  //     <div className="pl-3">
  //       <Chip
  //         color="success"
  //         variant="outlined"
  //         label="Approvato"
  //         icon={icons.ok}
  //       />
  //     </div>
  //   );
  /*eslint-disable-next-line*/
  if (value == statusRichiesta.inevaso)
    return (
      // pronto
      <div className="pl-0">
        <Chip
          color="warning"
          variant="outlined"
          label="Inevaso"
          icon={<FontAwesomeIcon icon={faBox} className="svg-icon-warning svg-icon-md" />}
          style={{ borderColor: "var(--warning)" }}
        />
      </div>
    );
  /*eslint-disable-next-line*/
  if (value == statusRichiesta.evaso)
    return (
      // consegnato
      <div className="pl-0">
        <Chip
          // color=""
          variant="outlined"
          label="Evaso"
          icon={<FontAwesomeIcon icon={faSquareCheck} className="svg-icon-primary svg-icon-md" />}
          style={{ borderColor: "var(--primary)", color: "var(--primary)" }}
        />
      </div>
    );
  /*eslint-disable-next-line*/
  if (value == statusRichiesta.rifiutato)
    return (
      // cancellato
      <div className="pl-0">
        <Chip
          // color="danger"
          variant="outlined"
          label="Rifiutato"
          icon={
            <span className="svg-icon svg-icon-md svg-icon-danger">
              {" "}
              <FontAwesomeIcon icon={faXmark} className="svg-icon-danger svg-icon-md" />
            </span>
          }
          style={{ borderColor: "var(--danger)", color: "var(--danger)" }}
        />
      </div>
    );
  return <div className="pl-0"></div>;
};

export const StatoFormattedColumn = (props) => <DataTypeProvider formatterComponent={StatoColumn} {...props} />;

const useStyles = makeStyles({
  noExtra: {
    width: 25,
    height: 25,
    backgroundColor: "var(--primary)",
  },
  extra: {
    width: 25,
    height: 25,
    backgroundColor: "var(--danger)",
  },
  // Nuovo stile per gli elementi rimossi in attesa
  removedItem: {
    textDecoration: "line-through",
    opacity: 0.5,
  },
});

const ExtraColumn = ({ value }) => {

  console.log('Valore Extra: ', value);
  const classes = useStyles();
  /*eslint-disable-next-line*/
  // if (value == false)
  // return (
  //     <Avatar className={classes.noExtra}>
  //             <span className="svg-icon svg-icon-md svg-icon-white">
  //                 {" "}
  //                 <FontAwesomeIcon icon={icons.close} />
  //             </span>
  //         </Avatar>
  //     );
  /*eslint-disable-next-line*/
  if (value == true)
    return (
      <Avatar className={classes.extra}>
        <span className="svg-icon svg-icon-md svg-icon-white">
          {" "}
           <SVG src={toAbsoluteUrl(icons.ok)} />
        </span>
        {/* <i className="ki ki-plus icon-white"></i> */}
      </Avatar>
    );
  return <></>;
};

export const ExtraFormattedColumn = (props) => <DataTypeProvider formatterComponent={ExtraColumn} {...props} />;

const QuantityInput = React.memo(({ rowId, item, updateLocalQuantityCallback, value }) => {
  const handleChange = (e) => {
    const newValue = parseInt(e.target.value) || 0;
    // Calcola i colli arrotondando per eccesso (Math.ceil)
    const colli = Math.max(0, Math.ceil(newValue / item.lot)); // Può essere 0 se l'utente mette 0 pezzi
    updateLocalQuantityCallback(rowId, item.idCampione, colli);
  };

  const handleFocus = (e) => {
    e.target.select();
  };

  // Visualizza sempre i pezzi
  const displayValue = value * item.lot;

  return (
    <input
      type="number"
      value={displayValue}
      onChange={handleChange}
      min={0} // Minimo 0 pezzi per permettere la "rimozione"
      style={{ width: "60px", textAlign: "center" }}
      onFocus={handleFocus}
      onKeyPress={(e) => e.key === "Enter" && e.target.blur()}
    />
  );
});

export const AddCampioneForm = ({ rowId, cart, campioniCatalog, addToCartCallback }) => {
  const [newCampione, setNewCampione] = useState(null);
  const [newCampioneQty, setNewCampioneQty] = useState(1);
  const [isAdding, setIsAdding] = useState(false);

  return (
    <div className="card card-custom bg-light border-dashed m-3">
      <div className="card-header border-0 py-3">
        <h6 className="font-weight-bold text-dark m-0">Aggiungi Campione</h6>
      </div>
      <div className="card-body">
        <div className="d-flex align-items-end">
          <div className="flex-grow-1 mr-3">
            <ArticoloEventoPicker
              options={campioniCatalog
                .filter((campione) => !cart.some((item) => item.sku === campione.sku))
                .map((campione) => ({
                  sku: campione.sku,
                  nomeArticolo: campione.name,
                  tipoArticolo: "campione",
                  image: campione.image,
                  qta: campione.qta,
                  division: campione.division,
                  _id: campione.id,
                  _lot: campione.quantity,
                }))}
              value={newCampione}
              onChange={setNewCampione}
            />
          </div>
          <div style={{ width: 80 }} className="mr-3">
            <Form.Control
              type="number"
              min="1"
              value={newCampioneQty}
              onChange={(e) => setNewCampioneQty(Math.max(1, parseInt(e.target.value) || 1))}
              placeholder="Colli"
            />
          </div>
          <Button
            variant="primary"
            disabled={!newCampione || isAdding}
            onClick={async () => {
              if (!newCampione) return;
              setIsAdding(true);
              try {
                await addToCartCallback(rowId, newCampione._id, newCampioneQty);
                setNewCampione(null);
                setNewCampioneQty(1);
              } catch (e) {
                console.error("Errore aggiunta campione:", e);
              } finally {
                setIsAdding(false);
              }
            }}
          >
            {isAdding ? "..." : "Aggiungi"}
          </Button>
        </div>
        <small className="text-muted">La quantità è espressa in colli.</small>
      </div>
    </div>
  );
};

const RichiestaRowDetail = ({
  getPrintRef,
  isRowLoading,
  isItemLoading,
  isEditing,
  editedValue,
  canApprove,
  updateStatusCallback,
  extraCallback,
  addToCartCallback,
  updateLocalQuantityCallback,
  removeFromCartCallback, // Mantenuto ma chiamato solo da handleSaveAllChanges
  openHistory,
  setOpenHistory,
  openPrice,
  setOpenPrice,
  isAdmin,
  isMagazziniere,
  pendingChanges,
  handleSaveAllChanges,
  isSavingAll,
  resetPendingChanges,
  updateTrackingCodeCallback,
}) => {
  const user = useSelector((state) => state.auth.user, shallowEqual);
  const printRefs = useRef({});
  const classes = useStyles(); // Usa gli stili definiti
  const shownQuantity = {};
  const [campioniCatalog, setCampioniCatalog] = useState([]);

  useEffect(() => {
    if (!user || !user.authToken) return;
    const role = parseInt(user.idRole);
    const fetchFn = role === roles.admin || role === roles.gestore || role === roles.developer ||
      role === roles.grafico || role === roles.magazziniere || role === roles.dipendente
      ? apiCampioni.getAll
      : apiCampioni.getCampioniByUserTargets;
    fetchFn(user.authToken)
      .then((data) => {
        const arr = Array.isArray(data) ? data : [];
        setCampioniCatalog(arr.filter((campione) => campione.available));
      })
      .catch(() => setCampioniCatalog([]));
    /*eslint-disable-next-line*/
  }, []);

  // Nuovi stati per il modal di conferma
  const [showRemoveConfirmation, setShowRemoveConfirmation] = useState(false);
  const [itemToRemoveDetails, setItemToRemoveDetails] = useState(null);

  // Funzione per aprire il modal di conferma
  const handleRemoveClick = (rowId, itemId) => {
    setItemToRemoveDetails({ rowId, itemId });
    setShowRemoveConfirmation(true);
  };

  // Funzione per confermare la rimozione (ora aggiorna lo stato locale)
  const handleConfirmRemove = () => {
    if (itemToRemoveDetails) {
      // Invece di rimuovere, imposta la quantità a 0 per marcare l'articolo come da rimuovere
      updateLocalQuantityCallback(itemToRemoveDetails.rowId, itemToRemoveDetails.itemId, 0);
      setShowRemoveConfirmation(false);
      setItemToRemoveDetails(null);
    }
  };

  // Funzione per chiudere il modal senza rimuovere
  const handleCloseRemoveModal = () => {
    setShowRemoveConfirmation(false);
    setItemToRemoveDetails(null);
  };

  return (
    <>
      <TableRowDetail
        contentComponent={({ row }) => {
          const isDisabled = {
            edit:
              (!canApprove && row.status != statusRichiesta.inAttesa) ||
              (canApprove && row.status == statusRichiesta.evaso),
            cancel:
              (!canApprove && row.status != statusRichiesta.inAttesa) ||
              (canApprove && (row.status == statusRichiesta.evaso || row.status == statusRichiesta.rifiutato)),
            setInevaso: row.status == statusRichiesta.inevaso || row.status == statusRichiesta.evaso,
            setEvaso: row.status == statusRichiesta.evaso,
          };

          for (var item of row.cart) {
            // Usa editedValue per la quantità mostrata se c'è una modifica pendente
            shownQuantity[item.idCampione] = isEditing(row.idRichiesta, item.idCampione)
              ? editedValue(row.idRichiesta, item.idCampione)
              : item.quantity;
          }

          // Funzione per attivare/disattivare la visibilità dello storico
          const toggleHistory = (idCampione) => {
            setOpenHistory((prevState) => ({
              ...prevState,
              [idCampione]: !prevState[idCampione],
            }));
          };

          const togglePrice = (idCampione) => {
            setOpenPrice((prevState) => ({
              ...prevState,
              [idCampione]: !prevState[idCampione],
            }));
          };

          // Funzione per verificare se lo storico è aperto
          const isHistoryClosed = (idCampione) => openHistory[idCampione] || false;

          // Funzione per verificare se i prezzi sono mostrati
          const isPriceOpen = (idCampione) => openPrice[idCampione] || false;

          const handlePrint = () => {
            const content = getPrintRef(row.idRichiesta)?.current;
            if (!content) return;

            // Crea un iframe invisibile
            const iframe = document.createElement("iframe");
            iframe.style.position = "absolute";
            iframe.style.top = "-9999px";
            iframe.style.left = "-9999px";
            iframe.style.width = "1px";
            iframe.style.height = "1px";
            document.body.appendChild(iframe);

            const doc = iframe.contentWindow.document;
            // Scrivi il contenuto nell'iframe
            doc.open();
            doc.write(`
    <html>
      <head>
        <title>Richiesta #${row.idRichiesta}</title>


        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css" />

        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css " />

        <style>
          body {
            font-family: Arial, sans-serif;
            padding: 12px;
            margin: 0;
          }
          table, tr, td, th {
            border: 1px solid #000;
            border-collapse: collapse;
            padding: 8px;
            text-align: left;
          }

          .no-print {
            display: none !important;
          }

          .symbol {
            display: inline-block;
            position: relative;
            vertical-align: middle;
            overflow: hidden;
        }

          .symbol.symbol-50 {
            width: 50px;
            height: 50px;
          }

          .symbol img {
            margin-right:22px;
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 0.42rem;
          }

          .font-size-lg {
            font-size:18px;
          }

          .print-chip-container {
            display: flex !important;
            flex-wrap: nowrap !important;
            overflow: hidden !important;
            width: 100% !important;
          }

          .print-chip-container .MuiChip-root {
            flex-shrink: 0 !important;
            white-space: nowrap !important;
            min-width: max-content !important;
          }

          .MuiChip-label {
    overflow: hidden;
    white-space: nowrap;
    padding-left: 12px;
    padding-right: 12px;
    text-overflow: ellipsis;
}
        </style>
      </head>
      <body>
        ${content.innerHTML}
      </body>
    </html>
  `);
            doc.close();

            // Avvia la stampa
            setTimeout(() => {
              iframe.contentWindow.focus();
              iframe.contentWindow.print();
              document.body.removeChild(iframe);
            }, 500);
          };
          // Evita l'aggiornamento di stato durante il render; usa fallback nel value
          return (
            <>
              <div
                key={`print-${row.idRichiesta}`}
                ref={getPrintRef(row.idRichiesta)}
                className="card printable-area w-100"
                data-row-id={row.idRichiesta}
              >
                {row.cart.map((item) => (
                  <div
                    key={item.idCampione} // Aggiungi una key univoca per gli elementi della lista
                    className={` d-flex align-items-start p-3 ${
                      shownQuantity[item.idCampione] === 0 ? classes.removedItem : ""
                    }`}
                  >
                    {typeof item.image !== "undefined" && item.image !== "" && item.image !== "0" ? (
                      <div className="symbol symbol-50 no-print mr-3">
                        <img src={toAbsoluteUrl(item.image)} alt="" />
                      </div>
                    ) : null}
                    <div className="d-flex flex-column mr-2 flex-grow-1">
                      <div className="d-flex align-items-center flex-nowrap">
                        <span className="font-weight-bold text-dark-75 font-size-lg text-hover-primary">
                          <span className="text-primary">{item.sku}</span> | {item.name} {item.qta}
                        </span>
                      </div>
                      <div className="printable-area d-flex align-items-center flex-wrap w-100">
                        
                        <span className="ml-2 mr-2 text-dark-75 font-size-1 text-muted text-nowrap">
                          <TagsFill className="d-inline-block align-middle mr-1" />{" "}
                          {shownQuantity[item.idCampione] * item.lot} pezzi
                        </span>
                        {isPriceOpen(item.idCampione) && (
                          <span className="mr-2 text-muted font-size-1 text-nowrap">
                            {typeof item.price !== "undefined"
                              ? ` | € ${(shownQuantity[item.idCampione] * item.price).toFixed(2)}`
                              : null}
                          </span>
                        )}
                        <span className="d-inline-flex align-items-center flex-nowrap no-print">
                          <span className="text-muted mr-2">=</span>

                          <span className="font-weight-bold mr-1 text-dark-75 font-size-1 text-nowrap">
                            <BoxSeamFill className="d-inline-block align-middle mr-1" />
                            {shownQuantity[item.idCampione] !== 1
                              ? `${shownQuantity[item.idCampione]} colli`
                              : "1 collo"}
                          </span>

                          <span className="text-dark-75 mr-1"> &#215; </span>

                          <span className="mr-2 text-dark-75 font-size-1 text-muted text-nowrap">
                            <TagFill className="d-inline-block align-middle mr-1" /> {item.lot} pz.
                          </span>
                        </span>
                        {isPriceOpen(item.idCampione) && (
                          <span className="mr-2 text-muted font-size-1">
                            {typeof item.price !== "undefined" ? `(€ ${item.price.toFixed(2)})` : null}
                          </span>
                        )}

                        {/* Bottone per mostrare/nascondere i prezzi */}
                        <Button
                          variant="outline-info"
                          className="btn p-1 pl-2 pr-2 rounded-pill m-2 flex no-print"
                          onClick={() => togglePrice(item.idCampione)}
                        >
                          {isPriceOpen(item.idCampione) ? (
                            <EyeSlashFill className="d-inline-block align-middle mr-1" />
                          ) : (
                            <Eye className="d-inline-block align-middle mr-1" />
                          )}
                          {isPriceOpen(item.idCampione) ? "Prezzi" : "Prezzi"}
                        </Button>
                        {/* Bottone per mostrare/nascondere lo storico  */}
                        {(isAdmin || isMagazziniere) && item.previous && item.previous.length > 0 && (
                          <Button
                            variant="outline-info"
                            className="btn p-1 pl-2 pr-2 rounded-pill m-2 flex no-print"
                            onClick={() => toggleHistory(item.idCampione)}
                          >
                            {!isHistoryClosed(item.idCampione) ? (
                              <EyeSlashFill className="d-inline-block align-middle mr-1" />
                            ) : (
                              <Eye className="d-inline-block align-middle mr-1" />
                            )}
                            {!isHistoryClosed(item.idCampione) ? "Storico" : "Storico"}
                          </Button>
                        )}
                      </div>

                      {/* Fine Titolo prodotto */}

                      <div className="flex print-chip-container">
                        {/* Sezione storico richieste (visibile solo se aperta) */}
                        {!isHistoryClosed(item.idCampione) && (
                          <>
                            {item.previous.map((prev, index) => (
                              <Chip
                                key={index} // Usa index come key, se non c'è un id unico
                                className="m-1 p-0 pl-1 pr-1"
                                variant="outlined"
                                icon={<Calendar color="primary" />}
                                label={`${moment(prev.data).format("MM/YY")}: ${prev.quantity * item.lot} pz.`}
                                sx={{ marginRight: 1, marginBottom: 1 }}
                              />
                            ))}
                          </>
                        )}

                        <div className="d-flex flex-row-reverse align-items-left mt-2">
                          <div className="d-flex-row">
                            {isDisabled.edit ? null : (
                              <OverlayTrigger overlay={<Tooltip>Rimuovi Articolo</Tooltip>}>
                                <Button
                                  variant="light-danger"
                                  className="btn-xs btn-icon ml-2"
                                  disabled={isItemLoading(row.idRichiesta, item.idCampione)}
                                  onClick={() => handleRemoveClick(row.idRichiesta, item.idCampione)} // Ora chiama handleRemoveClick
                                >
                                  <i className="ki ki-close icon-xs"></i>
                                </Button>
                              </OverlayTrigger>
                            )}
                          </div>
                          <div className="d-flex-row no-print">
                            {" "}
                            {/* Added flex-column and align-items-center for centering */}
                            {isDisabled.edit ? null : (
                              <>
                                <div className="d-flex align-items-center">
                                  {" "}
                                  {/* New div to group buttons and input */}
                                  {/* <label className="text-muted font-size-sm mb-2">Modifica Quantità</label>{" "} */}
                                  {/* New Label */}
                                  <OverlayTrigger overlay={<Tooltip>Rimuovi Collo</Tooltip>}>
                                    <Button
                                      variant="light-warning"
                                      className="btn-xs btn-icon mr-2"
                                      disabled={isItemLoading(row.idRichiesta, item.idCampione)}
                                      onClick={() =>
                                        updateLocalQuantityCallback(
                                          row.idRichiesta,
                                          item.idCampione,
                                          Math.max(0, shownQuantity[item.idCampione] - 1) // Può scendere a 0
                                        )
                                      }
                                    >
                                      <i className="ki ki-minus icon-xs"></i>
                                    </Button>
                                  </OverlayTrigger>
                                  <QuantityInput
                                    rowId={row.idRichiesta}
                                    item={item}
                                    updateLocalQuantityCallback={updateLocalQuantityCallback}
                                    value={shownQuantity[item.idCampione]} // Passa la quantità corrente o quella modificata
                                  />
                                  <OverlayTrigger overlay={<Tooltip>Aggiungi Collo</Tooltip>}>
                                    <Button
                                      variant="light-success"
                                      className="btn-xs btn-icon ml-2"
                                      disabled={isItemLoading(row.idRichiesta, item.idCampione)}
                                      onClick={() =>
                                        updateLocalQuantityCallback(
                                          row.idRichiesta,
                                          item.idCampione,
                                          shownQuantity[item.idCampione] + 1
                                        )
                                      }
                                    >
                                      <i className="ki ki-plus icon-xs"></i>
                                    </Button>
                                  </OverlayTrigger>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="separator separator-solid"></div>
                  </div>
                ))}
                {isDisabled.edit ? null : (
                  <AddCampioneForm
                    rowId={row.idRichiesta}
                    cart={row.cart}
                    campioniCatalog={campioniCatalog}
                    addToCartCallback={addToCartCallback}
                  />
                )}
                <div className="p-3">
                  <div className="d-flex align-items-center justify-content-xl-between mb-4">
                    <span className="font-weight-bold text-muted font-size-sm mr-2">Numero di colli</span>
                    <span className="font-weight-bolder text-primary text-right">
                      {row.cart.reduce((q, item) => q + shownQuantity[item.idCampione], 0)}
                    </span>
                  </div>
                  <div className="d-flex align-items-center justify-content-xl-between mb-7">
                    <span className="font-weight-bold text-muted font-size-sm mr-2">Campioni totali</span>
                    <span className="font-weight-bolder text-dark-50 text-right">
                      {row.cart.reduce((sum, item) => sum + shownQuantity[item.idCampione] * item.lot, 0)}
                    </span>
                  </div>
                  <div className="d-flex align-items-center justify-content-xl-between mb-7">
                    <span className="font-weight-bold text-muted font-size-sm mr-2">Valore totale</span>
                    <span className="font-weight-bolder text-dark-50 text-right">
                      {row.cart
                        .reduce(
                          (sum, item) =>
                            typeof item.price !== "undefined" ? sum + item.price * shownQuantity[item.idCampione] : sum,
                          0
                        )
                        .toFixed(2)}
                      €
                    </span>
                  </div>
                  <div className="d-flex align-items-center justify-content-xl-between mb-4">
                    <span className="font-weight-bold text-muted font-size-sm mr-2">Agente</span>
                    <span className="font-weight-bolder text-dark-50 text-right">{row.agente}</span>
                  </div>
                  <div className="d-flex align-items-center justify-content-xl-between mb-4">
                    <span className="font-weight-bold text-muted font-size-sm mr-2">Indirizzo</span>
                    <span className="font-weight-bolder text-dark-50 text-right">{row.address}</span>
                  </div>
                </div>
                <div className="separator separator-solid"></div>

                <TrackingCodeInput
                  canManage={canApprove}
                  row={row}
                  isRowLoading={isRowLoading}
                  updateTrackingCodeCallback={updateTrackingCodeCallback}
                />

                <div className="separator separator-solid"></div>
                <div>
                  <div className="float-xl-right no-print">
                    {/* Bottone "Salva tutte le modifiche" */}
                    {Object.keys(pendingChanges).length > 0 && ( // Mostra solo se ci sono modifiche pendenti
                      <Button
                        variant="primary"
                        className="mx-3 my-2"
                        onClick={() => handleSaveAllChanges(row.idRichiesta)}
                        disabled={isSavingAll}
                      >
                        {isSavingAll ? "Salvataggio..." : "Salva modifiche"}
                      </Button>
                    )}
                    {Object.keys(pendingChanges).length > 0 && ( // Pulsante Annulla modifiche
                      <Button
                        variant="light-danger"
                        className="mx-3 my-2"
                        onClick={() => resetPendingChanges(row.idRichiesta)}
                        disabled={isSavingAll}
                      >
                        Annulla
                      </Button>
                    )}

                    {makeActionBtn({
                      name: "Stampa",
                      callback: () => handlePrint(),
                      disabled: false,
                      variant: "success",
                      icon: faPrint,
                      value: row.idRichiesta,
                    })}

                    {makeActionBtn({
                      name: row.extra ? "Regolare" : "Extra",
                      callback: row.extra ? (id) => extraCallback(id, 0) : (id) => extraCallback(id, 1),
                      disabled: isRowLoading(row.idRichiesta) || isDisabled.edit,
                      variant: "info",
                      icon: icons.edit,
                      value: row.idRichiesta,
                    })}
                    {makeActionBtn({
                      name: canApprove ? "Rifiuta" : "Annulla",
                      callback: (id) => updateStatusCallback(id, statusRichiesta.rifiutato),
                      disabled: isRowLoading(row.idRichiesta) || isDisabled.cancel,
                      variant: "danger",
                      icon: icons.close,
                      value: row.idRichiesta,
                    })}
                    {canApprove
                      ? makeActionBtn({
                          name: "Pronto",
                          tooltip: "Pronto per ritiro/spedizione",
                          callback: (id) => updateStatusCallback(id, statusRichiesta.inevaso),
                          disabled: isRowLoading(row.idRichiesta) || isDisabled.setInevaso,
                          variant: "warning",
                          icon: faBox,
                          value: row.idRichiesta,
                        })
                      : null}
                    {canApprove
                      ? makeActionBtn({
                          name: "Evaso",
                          callback: (id) => updateStatusCallback(id, statusRichiesta.evaso),
                          disabled: isRowLoading(row.idRichiesta) || isDisabled.setEvaso,
                          variant: "primary",
                          icon: faSquareCheck,
                          value: row.idRichiesta,
                        })
                      : null}
                  </div>
                </div>
              </div>

              {/* Modal di conferma rimozione */}
              <Modal show={showRemoveConfirmation} onHide={handleCloseRemoveModal}>
                <Modal.Header closeButton>
                  <Modal.Title>Conferma Rimozione Articolo</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  Sei sicuro di voler rimuovere questo articolo dalla richiesta? L'articolo verrà rimosso solo al
                  salvataggio delle modifiche.
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleCloseRemoveModal}>
                    Annulla
                  </Button>
                  <Button variant="danger" onClick={handleConfirmRemove}>
                    Conferma Rimozione
                  </Button>
                </Modal.Footer>
              </Modal>
            </>
          );
        }}
      />
    </>
  );
};

// Columns definition
const colAgente = { name: "agente", title: "Agente" };
const colQuantity = { name: "quantity", title: "Q.tà" };
const colExtra = { name: "extra", title: "Extra" };
const colStatus = { name: "status", title: "Stato" };
const coldateCreated = { name: "dateCreated", title: "Dal" };
const colAddress = { name: "address", title: "Indirizzo" };

// Queste colonne sono sempre visibili
const alwaysColumns = [colAgente, colQuantity, colStatus, coldateCreated];
// Queste solo su desktop/tablet
const optionalColumns = [colExtra, colAddress];

const campioniColumnExtensions = [
  { columnName: colAgente.name, width: "auto", wordWrapEnabled: true },
  { columnName: colQuantity.name, width: 60, align: "center" },
  { columnName: colExtra.name, width: 60, align: "center" },
  { columnName: colStatus.name, width: 120 },
  { columnName: coldateCreated.name, width: "auto", wordWrapEnabled: true },
  { columnName: colAddress.name, width: "auto", wordWrapEnabled: true },
];

// Messages
const tableMessages = {
  noData: "Nessuna richiesta effettuata",
};
const filterRowMessages = {
  filterPlaceholder: "Filtra...",
};
const pagingPanelMessages = {
  showAll: "Tutte",
  rowsPerPage: "Righe per pagina",
  info: "Da {from} a {to} ({count} richieste)",
};

// Paging and sorting
const pageSizes = [10, 20, 30, 0];
const initialPageSize = 10;
const initialSorting = [{ columnName: "dateCreated", direction: "desc" }];

export const RichiesteCampioni = () => {
  const printRefs = useRef({});

  // table data
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingRows, setLoadingRows] = useState({});
  const [loadingItems, setLoadingItems] = useState({});
  const [pendingChanges, setPendingChanges] = useState({}); // Nuovo stato per le modifiche in sospeso
  const [isSavingAll, setIsSavingAll] = useState(false); // Nuovo stato per il salvataggio massivo
  const [_internalUpdateCount, _setInternalUpdateCount] = useState(0);

  const [openHistory, setOpenHistory] = useState({});
  const [openPrice, setOpenPrice] = useState({});

  // User redux
  const user = useSelector((state) => state.auth.user, shallowEqual);
  const role = parseInt(user.idRole);

  const isAdmin = role === roles.admin || role === roles.gestore || role === roles.developer;
  const isMagazziniere = role === roles.magazziniere;

  // Responsive: nascondi colonne Indirizzo ed Extra su mobile
  const isMobile = useIsMobile();

  // nascondi colonna "agente" se non admin/magazziniere
  let columns;
  if (role === roles.admin || role === roles.gestore || role === roles.developer || role === roles.magazziniere) {
    columns = isMobile ? [colAgente, colQuantity, colStatus, coldateCreated] : [...alwaysColumns, ...optionalColumns];
  } else {
    columns = isMobile
      ? [colQuantity, colStatus, coldateCreated]
      : [colQuantity, colStatus, coldateCreated, colExtra, colAddress];
  }

  const updateFromServer = () => {
    setLoading(true);
    apiRichieste
      .getAll(user.authToken)
      .then((data) => setRows(groupRichieste(data)))
      .then(() => setLoading(false));
  };
  useEffect(() => {
    updateFromServer();
    /*eslint-disable-next-line*/
  }, [_internalUpdateCount]);

  const doUpdate = () => {
    _setInternalUpdateCount(_internalUpdateCount + 1);
  };

  const addLoadingRow = (id) => {
    const clone = { ...loadingRows };
    clone[id] = true;
    setLoadingRows(clone);
  };
  const removeLoadingRow = (id) => {
    const clone = { ...loadingRows };
    delete clone[id];
    setLoadingRows(clone);
  };

  const addLoadingItem = (id, idCampione) => {
    const clone = { ...loadingItems };
    if (!(id in clone)) {
      clone[id] = {};
    }
    clone[id][idCampione] = true;
    setLoadingItems(clone);
  };
  const removeLoadingItem = (id, idCampione) => {
    const clone = { ...loadingItems };
    if (id in clone) {
      if (idCampione in clone[id]) {
        delete clone[id][idCampione];
      }
      if (Object.keys(clone[id]).length === 0) {
        // Controlla se l'oggetto interno è vuoto
        delete clone[id];
      }
    }
    setLoadingItems(clone);
  };

  // Funzione per aggiornare lo stato locale delle quantità (non invia al server)
  const updateLocalQuantity = (idRichiesta, idCampione, quantity) => {
    setPendingChanges((prev) => ({
      ...prev,
      [idRichiesta]: {
        ...(prev[idRichiesta] || {}),
        [idCampione]: quantity,
      },
    }));
  };

  // Funzione per verificare se un elemento ha modifiche pendenti
  const isEditing = (idRichiesta, idCampione) => {
    return idRichiesta in pendingChanges && idCampione in pendingChanges[idRichiesta];
  };

  // Funzione per ottenere il valore modificato (o originale se non modificato)
  const getEditedValue = (idRichiesta, idCampione) => {
    if (isEditing(idRichiesta, idCampione)) {
      return pendingChanges[idRichiesta][idCampione];
    }
    // Trova il valore originale
    const richiesta = rows.get(idRichiesta);
    if (richiesta) {
      const item = richiesta.cart.find((c) => c.idCampione === idCampione);
      return item ? item.quantity : undefined;
    }
    return undefined;
  };

  // Funzione per resettare le modifiche pendenti per una riga specifica
  const resetPendingChanges = (idRichiesta) => {
    setPendingChanges((prev) => {
      const newPending = { ...prev };
      delete newPending[idRichiesta];
      return newPending;
    });
  };

  // Funzione per salvare tutte le modifiche pendenti
  const handleSaveAllChanges = async (idRichiesta) => {
    setIsSavingAll(true);
    addLoadingRow(idRichiesta);

    const changesToSave = pendingChanges[idRichiesta];
    if (!changesToSave) {
      removeLoadingRow(idRichiesta);
      setIsSavingAll(false);
      return;
    }

    const promises = Object.keys(changesToSave).map(async (idCampione) => {
      const newQuantity = changesToSave[idCampione];
      addLoadingItem(idRichiesta, idCampione);
      try {
        if (newQuantity === 0) {
          // Se la quantità è 0, rimuovi l'articolo
          await apiRichieste.removeFromCart(user.authToken, idRichiesta, idCampione);
        } else {
          // Altrimenti, aggiorna la quantità
          await apiRichieste.updateCartQuantity(user.authToken, idRichiesta, idCampione, newQuantity);
        }
      } catch (error) {
        console.error("Errore durante il salvataggio della quantità/rimozione:", error);
      } finally {
        removeLoadingItem(idRichiesta, idCampione);
      }
    });

    await Promise.all(promises);
    removeLoadingRow(idRichiesta);
    resetPendingChanges(idRichiesta); // Resetta le modifiche pendenti dopo il salvataggio
    doUpdate(); // Aggiorna i dati dal server per riflettere le modifiche
    setIsSavingAll(false);
  };

  // paging and sorting
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(initialPageSize);
  const [sorting, setSorting] = useState(initialSorting);
  const [expandedRows, setExpandedRows] = useState([]);

  /*eslint-disable-next-line*/
  //const campioniMap = new Map(rows.map((c) => [c.id, c]));
  return (
    <>
      <Card className="card-custom gutter-b">
        <Card.Header className="border-0 py-5 row">
          <Card.Title className="float-left col-auto">
            <div>
              <h3 className="font-weight-bolder text-dark">Richieste di Campioni</h3>
              {isMobile && (
                <h6 className="font-weight-light text-dark">
                  Alcune colonne sono nascoste su mobile per una migliore leggibilità.
                </h6>
              )}
            </div>
          </Card.Title>
        </Card.Header>
        <Card.Body className="p-0 m-0">
          <div className="mr-3 ml-3 alert alert-secondary text-right" role="alert">
            <strong>Legenda stati</strong> 0: In attesa, 1: Approvato, 2: Rifiutato
          </div>
          {!loading ? (
            <Grid rows={[...rows.values()]} columns={columns}>
              <DateFormattedColumn for={["dateCreated"]} />
              <StatoFormattedColumn for={["status"]} />
              <ExtraFormattedColumn for={["extra"]} />
              <RowDetailState expandedRowIds={expandedRows} onExpandedRowIdsChange={setExpandedRows} />
              <FilteringState />
              <IntegratedFiltering
                columnExtensions={
                  [
                    // { columnName: "quantity", predicate: () => false },
                    // { columnName: "extra", predicate: () => false },
                  ]
                }
              />
              <PagingState
                currentPage={currentPage}
                onCurrentPageChange={setCurrentPage}
                pageSize={pageSize}
                onPageSizeChange={setPageSize}
              />
              <IntegratedPaging />
              <SortingState sorting={sorting} onSortingChange={setSorting} />
              <IntegratedSorting />
              <Table
                messages={tableMessages}
                tableComponent={TableComponent}
                columnExtensions={campioniColumnExtensions}
                rowComponent={getTableRow((id) =>
                  setExpandedRows(
                    expandedRows.includes(id) ? [...expandedRows].filter((v) => v != id) : [...expandedRows, id]
                  )
                )}
                cellComponent={Cell}
              />
              <TableHeaderRow cellComponent={HeaderCell} showSortingControls />
              <TableFilterRow messages={filterRowMessages} cellComponent={FilterCell} />
              <RichiestaRowDetail
                getPrintRef={(id) => {
                  if (!printRefs.current[id]) printRefs.current[id] = React.createRef();
                  return printRefs.current[id];
                }}
                /*eslint-disable-next-line*/
                canApprove={role === roles.admin || role === roles.gestore || role === roles.developer || role === roles.magazziniere}
                isAdmin={isAdmin}
                isMagazziniere={isMagazziniere}
                isRowLoading={(id) => id in loadingRows}
                isItemLoading={(id, idCampione) => id in loadingItems && idCampione in loadingItems[id]}
                isEditing={isEditing} // Usa la nuova funzione
                editedValue={getEditedValue} // Usa la nuova funzione
                openHistory={openHistory}
                setOpenHistory={setOpenHistory}
                setOpenPrice={setOpenPrice}
                openPrice={openPrice}
                extraCallback={(id, extra) => {
                  addLoadingRow(id);
                  apiRichieste.extra(user.authToken, id, extra).then(() => {
                    removeLoadingRow(id);
                    doUpdate();
                  }).catch(() => removeLoadingRow(id));
                }}
                addToCartCallback={(id, idCampione, quantity) => {
                  addLoadingRow(id);
                  return apiRichieste.addToCart(user.authToken, id, idCampione, quantity).then(() => {
                    removeLoadingRow(id);
                    doUpdate();
                  }).catch((e) => {
                    removeLoadingRow(id);
                    throw e;
                  });
                }}
                updateStatusCallback={(id, status, trackingCode) => {
                  addLoadingRow(id);
                  apiRichieste.update(user.authToken, id, status, trackingCode).then(() => {
                    removeLoadingRow(id);
                    doUpdate();
                  });
                }}
                updateTrackingCodeCallback={(id, trackingCode) => {
                  addLoadingRow(id);
                  apiTracking.updateTrackingCode(user.authToken, id, trackingCode, "campione").then(() => {
                    removeLoadingRow(id);
                    doUpdate();
                  });
                }}
                updateLocalQuantityCallback={updateLocalQuantity} // Nuova callback per aggiornare lo stato locale
                removeFromCartCallback={(id, idCampione) => {
                  // Questa callback non sarà più chiamata direttamente dal pulsante di rimozione,
                  // ma verrà utilizzata da handleSaveAllChanges
                  addLoadingItem(id, idCampione);
                  apiRichieste.removeFromCart(user.authToken, id, idCampione).then(() => {
                    removeLoadingItem(id, idCampione);
                    doUpdate();
                  });
                }}
                pendingChanges={pendingChanges} // Passa lo stato delle modifiche pendenti
                handleSaveAllChanges={handleSaveAllChanges} // Passa la funzione per il salvataggio massivo
                isSavingAll={isSavingAll} // Passa lo stato di salvataggio massivo
                resetPendingChanges={resetPendingChanges} // Passa la funzione per resettare le modifiche
              />
              <PagingPanel messages={pagingPanelMessages} pageSizes={pageSizes} />
            </Grid>
          ) : (
            <div>
              <Skeleton variant="text" />
              <Skeleton variant="text" />
              <Skeleton variant="text" />
              <Skeleton variant="rect" height={518} />
            </div>
          )}
        </Card.Body>
      </Card>
    </>
  );
};
